module.exports = __webpack_public_path__ + "img/zc.1a545dfc.png";